import { render } from "./blog-grid-sidebar-right.vue?vue&type=template&id=f76fc0f6"
import script from "./blog-grid-sidebar-right.vue?vue&type=script&lang=js"
export * from "./blog-grid-sidebar-right.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__